export function l10n (code, language = 'ko') {
  const text = {
    // 공통
    'common.top': {
      'ko': '페이지 위로가기',
      'zh': '回到最上面',
      'ja': 'ページ トップに戻る',
      'en': 'Back to Top',
      'ru': 'Наверх страницы',
      'id': 'Kembali ke Atas',
      'th': 'ขึ้นไปบนสุด',
      'ar': 'العودة إلى أعلى الصفحة'
    },
    'common.prev': {
      'ko': '이전',
      'zh': '上一頁',
      'ja': '戻る',
      'en': 'Previous',
      'ru': 'Назад',
      'id': 'Sebelumnya',
      'th': 'ก่อนหน้า',
      'ar': 'السابق'
    },
    'common.next': {
      'ko': '다음',
      'zh': '下一頁',
      'ja': '次へ',
      'en': 'Next',
      'ru': 'Далее',
      'id': 'Selanjutnya',
      'th': 'ถัดไป',
      'ar': 'التالي'
    },
    'common.update': {
      'ko': '업데이트',
      'zh': '更新',
      'ja': 'アップデート',
      'en': 'Update',
      'ru': 'Обновление',
      'id': 'Update',
      'th': 'อัปเดต',
      'ar': 'تحديث'
    },

    // 상단 검색 UI
    'search.title': {
      'ko': '가이드북 검색',
      'zh': '搜尋指南',
      'ja': 'ガイドブック検索',
      'en': 'Search Guidebook',
      'ru': 'Поиск по путеводителю',
      'id': 'Cari di Buku Panduan',
      'th': 'ค้นหาคู่มือ',
      'ar': 'البحث عن دليل'
    },
    'search.placeholder': {
      'ko': '가이드북 검색',
      'zh': '搜尋指南',
      'ja': 'ガイドブック検索',
      'en': 'Search Guidebook',
      'ru': 'Поиск по путеводителю',
      'id': 'Cari di Buku Panduan',
      'th': 'ค้นหาคู่มือ',
      'ar': 'البحث عن دليل'

    },
    'search.placeholder.l2': {
      'ko': '본서버 가이드북 검색',
      'zh': '搜尋指南',
      'ja': '本サーバー ガイドブック検索',
      'en': 'Search Main Server Guidebook',
      'ru': 'Поиск по путеводителю классического сервера',
      'id': 'Cari di Buku Panduan Server Utama',
      'th': 'ค้นหาคู่มือเซิร์ฟเวอร์เดิม',
      'ar': 'البحث في دليل الخادم الرئيسي'
    },
    'search.placeholder.l2awkn': {
      'ko': '각성서버 가이드북 검색',
      'zh': '搜尋指南',
      'ja': '覚醒サーバー ガイドブック検索',
      'en': 'Search Awakening Server Guidebook',
      'ru': 'Поиск по путеводителю сервера пробуждения',
      'id': 'Cari di Buku Panduan Server Kebangkitan',
      'th': 'ค้นหาคู่มือเซิร์ฟเวอร์รู้แจ้ง',
      'ar': 'البحث في دليل خادم الصحوة'
    },
    'search.reset': {
      'ko': '삭제',
      'zh': '刪除',
      'ja': '削除',
      'en': 'Delete',
      'ru': 'Удалить',
      'id': 'Hapus',
      'th': 'ลบ',
      'ar': 'حذف'
    },
    'search.submit': {
      'ko': '검색',
      'zh': '搜尋',
      'ja': '検索',
      'en': 'Search',
      'ru': 'Поиск',
      'id': 'Cari',
      'th': 'ค้นหา',
      'ar': 'بحث'
    },
    'search.none': {
      'ko': '최근검색어 내역이 없습니다.',
      'zh': '沒有最近的搜尋紀錄',
      'ja': '最近の検索ワード履歴がありません。',
      'en': 'No recent keyword history.',
      'ru': 'История поиска отсутствует.',
      'id': 'Tidak ada riwayat pencarian terbaru.',
      'th': 'ไม่มีข้อมูลคำค้นหาล่าสุด',
      'ar': 'لا يوجد تفاصيل بحث حديثة.'
    },
    'search.clear': {
      'ko': '최근 검색어 전체 삭제',
      'zh': '刪除最近搜尋的所有紀錄',
      'ja': '最近の検索ワード全削除',
      'en': 'Delete All Recent Keywords',
      'ru': 'Удалить историю поиска',
      'id': 'Hapus Riwayat Pencarian Terbaru',
      'th': 'ลบคำค้นหาล่าสุดทั้งหมด',
      'ar': 'حذف كل مصطلحات البحث الحديثة'
    },
    'search.list': {
      'ko': '가이드 목록',
      'zh': '指南',
      'ja': 'ガイド リスト',
      'en': 'Guidebook List',
      'ru': 'Список путеводителей',
      'id': 'Daftar Panduan',
      'th': 'รายการไกด์',
      'ar': 'قائمة الدليل'
    },
    'search.popular': {
      'ko': '인기 검색어',
      'zh': '熱門搜尋',
      'ja': '人気検索ワード',
      'en': 'Popular Keyword',
      'ru': 'Популярные запросы',
      'id': 'Kata Pencarian Populer',
      'th': 'คำค้นหายอดฮิต',
      'ar': 'مصطلحات البحث المشهورة'
    },
    'search.alert.none': {
      'ko': '검색어를 입력해주세요.',
      'zh': '請輸入關鍵字',
      'ja': '検索ワードを入力してください。',
      'en': 'Please enter a keyword.',
      'ru': 'Введите поисковый запрос.',
      'id': 'Silakan masukkan kata yang ingin dicari.',
      'th': 'โปรดกรอกคำค้นหา',
      'ar': 'الرجاء إدخال مصطلح البحث.'
    },
    'search.delete': {
      'ko': '검색어 삭제',
      'zh': '刪除關鍵字',
      'ja': '検索ワード削除',
      'en': 'Delete Keyword',
      'ru': 'Удалить поисковый запрос',
      'id': 'Hapus Kata Pencarian',
      'th': 'ลบคำค้นหา',
      'ar': 'حذف مصطلح البحث'
    },
    'search.alert.unavailable': {
      'ko': '사용할 수 없는 검색어가 포함되어 있습니다. (# & ^ = [ ] { } \\ | % ; , ? < >)',
      'zh': '包含無法使用的的搜尋用語(# & ^ = [ ] { } \\\\ | % ; , ? < >)',
      'ja': '使用できない記号が含まれています。(# & ^ = [ ] { } \\\\ | % ; , ? < >)',
      'en': 'Includes one or more invalid keywords (# & ^ = [ ] { } \\\\ | % ; , ? < >).',
      'ru': 'Поисковый запрос не может содержать символы (# & ^ = [ ] { } \\\\ | % ; , ? < >).',
      'id': 'Terdapat karakter yang tidak dapat digunakan. (# & ^ = [ ] { } \\\\ | % ; , ? < >)',
      'th': 'มีคำค้นหาที่ไม่สามารถใช้งานได้ร่วมอยู่ (# & ^ = [ ] { } \\\\ | % ; , ? < >)',
      'ar': 'يتم تضمين مصطلح بحث غير صالح. (# & ^ = [ ] { } \\\\ | % ; , ? < >)'
    },

    // 인덱스 페이지
    'index.popular.title': {
      'ko': '인기 가이드',
      'zh': '人氣指南',
      'ja': '人気ガイド',
      'en': 'Popular Guide',
      'ru': 'Популярный путеводитель',
      'id': 'Panduan Populer',
      'th': 'คู่มือยอดฮิต',
      'ar': 'الدليل الشعبي'
    },

    'index.newest.title': {
      'ko': '최신 가이드',
      'zh': '最新指南',
      'ja': '最新ガイド',
      'en': 'New Guide',
      'ru': 'Новые руководства',
      'id': 'Panduan Terbaru',
      'th': 'ไกด์ล่าสุด',
      'ar': 'أحدث دليل'
    },

    'index.basic.title': {
      'ko': '기본 가이드',
      'zh': '基本指南',
      'ja': '基本ガイド',
      'en': 'Basic Guide',
      'ru': 'Стандартный путеводитель',
      'id': 'Panduan Dasar',
      'th': 'คู่มือเริ่มต้น',
      'ar': 'الدليل الأساسي'
    },
    

    // 목록 페이지
    'category.all': {
      'ko': '전체 카테고리',
      'zh': '查看全部目錄',
      'ja': '全体リスト表示',
      'en': 'All Categories',
      'ru': 'Все категории',
      'id': 'Semua Kategori',
      'th': 'หมวดหมู่ทั้งหมด',
      'ar': 'كل الفئات'
    },
    'list.all': {
      'ko': '전체 목록 보기',
      'zh': '查看全部目錄',
      'ja': '全体リスト表示',
      'en': 'View All Lists',
      'ru': 'Смотреть полный список',
      'id': 'Lihat Semua Daftar',
      'th': 'ดูรายการทั้งหมด',
      'ar': 'عرض القائمة الكاملة'
    },
    'list.none.registered': {
      'ko': '등록된 가이드가 없습니다.',
      'zh': '沒有登錄的指南',
      'ja': '登録されたガイドがありません。',
      'en': 'There is no registered Guidebook.',
      'ru': 'Нет зарегистрированных путеводителей.',
      'id': 'Tidak ada panduan yang terdaftar.',
      'th': 'ไม่มีไกด์ที่ลงทะเบียนไว้',
      'ar': 'لا يوجد دليل مسجل.'
    },
    'list.none.new': {
      'ko': '새로 등록된 가이드가 없습니다.',
      'zh': '沒有新登錄的指南',
      'ja': '新しく登録されたガイドがありません。',
      'en': 'There is no newly registered Guidebook.',
      'ru': 'Нет новых зарегистрированных путеводителей.',
      'id': 'Tidak ada panduan baru.',
      'th': 'ไม่มีไกด์ที่ลงทะเบียนใหม่',
      'ar': 'لا يوجد دليل مسجل حديثا.'
    },
    'list.none.updated': {
      'ko': '업데이트된 가이드가 없습니다.',
      'zh': '沒有更新的指南',
      'ja': 'アップデートされたガイドがありません。',
      'en': 'There is no updated Guidebook.',
      'ru': 'Нет обновленных путеводителей.',
      'id': 'Tidak ada panduan yang diperbarui.',
      'th': 'ไม่มีไกด์ที่ถูกอัปเดต',
      'ar': 'لا يوجد دليل تم تحديثه.'
    },

    // 검색 페이지
    'search.result': {
      'ko': '검색결과',
      'zh': '搜尋結果',
      'ja': '検索結果',
      'en': 'Search Results',
      'ru': 'Результаты поиска:',
      'id': 'Hasil Pencarian:',
      'th': 'ผลการค้นหา',
      'ar': 'نتائج البحث'
    },
    'search.option.content': {
      'ko': '제목 + 내용',
      'zh': '標題 + 內容',
      'ja': 'タイトル + 内容',
      'en': 'Title + Description',
      'ru': 'Название и содержание',
      'id': 'Judul + Isi',
      'th': 'หัวข้อ+เนื้อหา',
      'ar': 'العنوان + المحتوى'
    },
    'search.option.title': {
      'ko': '제목',
      'zh': '標題',
      'ja': 'タイトル',
      'en': 'Title',
      'ru': 'Название',
      'id': 'Judul',
      'th': 'หัวข้อ',
      'ar': 'عنوان'
    },
    'search.option.tag': {
      'ko': '태그',
      'zh': '標籤',
      'ja': 'タグ',
      'en': 'Tag',
      'ru': 'Тэг',
      'id': 'Tag',
      'th': 'แท็ก',
      'ar': 'هاشتاغ'
    },
    'search.result.none.keyword': {
      'ko': `'${arguments[2]}'에 대한 검색 결과가 없습니다.`,
      'zh': `沒有'${arguments[2]}'的相關搜尋結果`,
      'ja': `'${arguments[2]}'に対する検索結果がありません。`,
      'en': `There are no search results for '${arguments[2]}'.`,
      'ru': `По запросу «${arguments[2]}» ничего не найдено.`,
      'id': `Tidak ada hasil pencarian tentang '${arguments[2]}'.`,
      'th': `ไม่พบผลการค้นหาที่เกี่ยวกับ '${arguments[2]}'`,
      'ar': `لا يوجد نتيجة بحث حول "${arguments[2]}".
`
    },
    'search.description1': {
      'ko': '단어의 철자가 정확한지 확인해 주세요.',
      'zh': '請確認關鍵字輸入是否正確',
      'ja': 'ワードのつづりが正しいか確認してください。',
      'en': 'Please check the spelling of the keyword.',
      'ru': 'Проверьте правильность написания поискового запроса.',
      'id': 'Pastikan bahwa ejaan kata yang dicari sudah tepat.',
      'th': 'โปรดตรวจสอบการสะกดคำว่าถูกต้องหรือไม่',
      'ar': 'الرجاء التحقق من كتابة الكلمات بشكل صحيح.'
    },
    'search.description2': {
      'ko': '검색어의 단어 수를 줄이거나 보다 일반적인 검색어로 검색해 보세요.',
      'zh': '請減少關鍵字數或用一般關鍵字搜尋看看',
      'ja': '検索ワード数を減らして、より一般的な検索ワードで検索してみてください。',
      'en': 'Try entering fewer words or more common keywords.',
      'ru': 'Уменьшите количество слов в поиске или попробуйте использовать более стандартные слова.',
      'id': 'Silakan coba kurangi jumlah kata atau cari menggunakan kata yang lebih umum.',
      'th': 'ลองลดจำนวนคำในคำค้นหาของคุณ หรือลองใช้คำค้นหาที่กว้างกว่านี้',
      'ar': 'الرجاء تقليل عدد الكلمات في مصطلح البحث الخاص بك أو جرب مصطلح بحث أكثر عمومية.'
    },
    'search.description3': {
      'ko': '검색어가 두 단어 이상일 경우 띄어쓰기를 확인해 보세요.',
      'zh': '若為兩個以上的關鍵字, 請使用空格間隔',
      'ja': '検索ワードが2つ以上の場合、半角スペースを挿入してみてください。',
      'en': 'If you have to enter two or more keywords, try adding spacing between the two.',
      'ru': 'В случае наличия двух и более слов в поисковом запросе, проверьте наличие пробелов.',
      'id': 'Ketika mencari lebih dari 2 kata, silakan coba periksa spasi di antara kata yang dicari.',
      'th': 'หากข้อความค้นหาเกินสองคำ ลองตรวจสอบเว้นวรรคดู',
      'ar': 'إذا كان مصطلح البحث أكثر من كلمتين، فالرجاء التحقق من التباعد.'
    },
    'search.result.count': {
      'ko': `총 ${arguments[2]}건`,
      'zh': `總共${arguments[2]}筆`,
      'ja': `合計${arguments[2]}件`,
      'en': `Total: ${arguments[2]}`,
      'ru': `Всего результатов: ${arguments[2]}`,
      'id': `${arguments[2]}`,
      'th': `ทั้งหมด ${arguments[2]} รายการ`,
      'ar': ` مجموع: ${arguments[2]}نتيجة `
    },
    'search.result.none': {
      'ko': '검색 결과가 없습니다.',
      'zh': '沒有搜尋結果',
      'ja': '検索結果がありません。',
      'en': 'There are no search results.',
      'ru': 'По вашему запросу ничего не найдено.',
      'id': 'Tidak ada hasil pencarian.',
      'th': 'ไม่พบผลการค้นหา',
      'ar': 'لا يوجد نتيجة بحث.'
    },

    // 뷰 페이지
    'view.toc': {
      'ko': '목차',
      'zh': '目錄',
      'ja': '目次',
      'en': 'Contents',
      'ru': 'Оглавление',
      'id': 'Topik',
      'th': 'รายการ',
      'ar': 'فهرس'
    },
    'view.toc.close': {
      'ko': '목차 닫기',
      'zh': '關閉目錄',
      'ja': '目次を閉じる',
      'en': 'Close Contents',
      'ru': 'Закрыть оглавление',
      'id': 'Tutup Topik',
      'th': 'ปิดรายการ',
      'ar': 'غلق الفهرس'
    },
    'view.relation': {
      'ko': '연관',
      'zh': '相關',
      'ja': '関連',
      'en': 'Related',
      'ru': 'Связанное',
      'id': 'Terkait',
      'th': 'เกี่ยวข้อง',
      'ar': 'صلة'
    },
    'view.recommand': {
      'ko': '추천',
      'zh': '推薦',
      'ja': 'おすすめ',
      'en': 'Like',
      'ru': 'Рекомендованное',
      'id': 'Rekomendasi',
      'th': 'แนะนำ',
      'ar': 'توصية'
    },
    'view.relation-page': {
      'ko': '연관페이지',
      'zh': '相關',
      'ja': '関連',
      'en': 'Related Page',
      'ru': 'Связанные страницы',
      'id': 'Halaman Terkait',
      'th': 'เพจที่เกี่ยวข้อง',
      'ar': 'صفحة ذات صلة'
    },
    'view.update.description': {
      'ko': `이 문서는 ${arguments[2]}에 업데이트 되었습니다. 일부 내용은 게임과 다를 수 있으며 자세한 내용은 <a class="link" href="${arguments[3]}">업데이트 공지</a>를 참고 부탁드립니다.`,
      'zh': `該文章在${arguments[2]} 所更新， 部份內容可能會與遊戲內有差異，詳細內容請參考<a class="link" href="${arguments[3]}">改版公告</a>。`,
      'ja': `このテキストは ${arguments[2]}にアップデートされました。一部内容はゲームと相違する場合がありますので、詳細内容は<a class="link" href="${arguments[3]}">アップデート告知</a>を参考してください。`,
      'en': `This page was updated in ${arguments[2]}. Some details may differ from the game. Please refer to <a class="link" href="${arguments[3]}">Update Notice</a> for more information.`,
      'ru': `Данный документ был обновлен в ${arguments[2]} Некоторые элементы могут отличаться от внутриигровых. С дополнительной информацией можно ознакомиться в разделе <a class="link" href="${arguments[3]}">Патчноуты</a>.`,
      'id': `Halaman ini diperbarui pada ${arguments[2]} Sebagian informasi yang tertera dapat berbeda dengan yang terdapat pada game. Untuk informasi lebih lanjut, silakan mengacu pada <a class="link" href="${arguments[3]}">Pengumuman Update</a>.`,
      'th': ` เอกสารที่ได้ถูกอัพเดตเมื่อ ${arguments[2]} เนื้อหาบางส่วนอาจต่างจากเกมได้ สำหรับรายละเอียดเพิ่มเติม กรุณาตรวจสอบ <a class="link" href="${arguments[3]}">ประกาศอัปเดต</a>`,
      'ar': `تم تحديث هذا المستند في ${arguments[2]}    قد يختلف بعض المحتوى عن اللعبة. للمزيد من التفاصيل، الرجاء الرجوع إلى <a class="link" href="${arguments[3]}">إشعار تحديث</a>.`
    },
  };

  return text[code][language];
}
